// Comprehensive dataset of vehicle makes and the models most commonly found on
// Zambia's roads (dominated by used "grey" imports from Japan, the UK and South
// Africa). Used for SEO content, structured data (JSON-LD) and on-page browsing.
//
// Sources of truth: popular Japanese, European, Korean, Indian and Chinese
// brands imported through Dar es Salaam / Durban and sold across Lusaka, Kitwe,
// Ndola, Livingstone, Kabwe, Chingola, Solwezi and beyond.

export const carMakes = [
  {
    name: 'Toyota',
    popular: [
      'Corolla', 'Corolla Axio', 'Premio', 'Allion', 'Mark X', 'Camry', 'Avensis',
      'Vitz', 'Passo', 'Belta', 'Aqua', 'Prius', 'Harrier', 'RAV4', 'Rush',
      'Fortuner', 'Land Cruiser', 'Land Cruiser Prado', 'Hilux', 'Hilux Surf',
      'Hiace', 'Quantum', 'Noah', 'Voxy', 'Wish', 'Ist', 'Probox', 'Succeed',
      'Ractis', 'Funcargo', 'Spacio', 'bB', 'Crown', 'Dyna',
    ],
  },
  {
    name: 'Nissan',
    popular: [
      'Note', 'March', 'Tiida', 'Sunny', 'Almera', 'Bluebird Sylphy', 'Teana',
      'X-Trail', 'Qashqai', 'Juke', 'Dualis', 'Murano', 'Patrol', 'Navara',
      'Hardbody', 'NP200', 'NP300', 'Wingroad', 'AD Van', 'Serena', 'Elgrand',
      'Caravan', 'Urvan', 'Fuga', 'Skyline',
    ],
  },
  {
    name: 'Honda',
    popular: [
      'Fit', 'Fit Aria', 'Civic', 'Accord', 'Insight', 'Vezel', 'CR-V', 'HR-V',
      'Stream', 'Stepwgn', 'Freed', 'Airwave', 'Mobilio', 'Odyssey', 'Shuttle',
    ],
  },
  {
    name: 'Mitsubishi',
    popular: [
      'Pajero', 'Pajero IO', 'Shogun', 'Outlander', 'ASX', 'RVR', 'Lancer',
      'Colt', 'Galant', 'Triton', 'L200', 'Canter', 'Fuso', 'Delica', 'Chariot',
    ],
  },
  {
    name: 'Mazda',
    popular: [
      'Demio', 'Axela', 'Atenza', 'Familia', 'Premacy', 'MPV', 'Tribute',
      'CX-3', 'CX-5', 'CX-7', 'BT-50', 'Bongo', 'Verisa',
    ],
  },
  {
    name: 'Subaru',
    popular: [
      'Forester', 'Outback', 'Legacy', 'Impreza', 'XV', 'Exiga', 'Levorg',
    ],
  },
  {
    name: 'Suzuki',
    popular: [
      'Swift', 'Alto', 'Wagon R', 'Vitara', 'Grand Vitara', 'Escudo', 'Jimny',
      'Ignis', 'Celerio', 'Every', 'APV', 'Ertiga',
    ],
  },
  {
    name: 'Isuzu',
    popular: [
      'D-Max', 'KB', 'MU-X', 'Trooper', 'Bighorn', 'NPR', 'NQR', 'FRR', 'FVR',
      'Forward', 'Elf',
    ],
  },
  {
    name: 'Toyota Hino',
    popular: ['Dutro', 'Ranger', '300 Series', '500 Series', '700 Series'],
  },
  {
    name: 'Volkswagen',
    popular: [
      'Polo', 'Polo Vivo', 'Golf', 'Jetta', 'Passat', 'Tiguan', 'Touareg',
      'Caddy', 'Amarok', 'T-Cross',
    ],
  },
  {
    name: 'Mercedes-Benz',
    popular: [
      'A-Class', 'C-Class', 'E-Class', 'S-Class', 'CLA', 'GLA', 'GLC', 'GLE',
      'ML', 'Sprinter', 'Vito', 'Viano', 'Actros', 'Atego',
    ],
  },
  {
    name: 'BMW',
    popular: ['1 Series', '3 Series', '5 Series', '7 Series', 'X1', 'X3', 'X5', 'X6'],
  },
  {
    name: 'Audi',
    popular: ['A1', 'A3', 'A4', 'A6', 'Q3', 'Q5', 'Q7'],
  },
  {
    name: 'Ford',
    popular: [
      'Ranger', 'Everest', 'Figo', 'Fiesta', 'Focus', 'EcoSport', 'Kuga', 'Territory',
    ],
  },
  {
    name: 'Hyundai',
    popular: [
      'i10', 'Grand i10', 'i20', 'Accent', 'Elantra', 'Tucson', 'Santa Fe',
      'Creta', 'Venue', 'H-1', 'H100',
    ],
  },
  {
    name: 'Kia',
    popular: [
      'Picanto', 'Rio', 'Cerato', 'Sportage', 'Sorento', 'Seltos', 'Pegas', 'K2700',
    ],
  },
  {
    name: 'Land Rover',
    popular: ['Defender', 'Discovery', 'Discovery Sport', 'Range Rover', 'Range Rover Sport', 'Freelander'],
  },
  {
    name: 'Lexus',
    popular: ['IS', 'ES', 'RX', 'GX', 'LX', 'NX'],
  },
  {
    name: 'Chevrolet',
    popular: ['Spark', 'Aveo', 'Sonic', 'Cruze', 'Captiva', 'Trailblazer', 'Utility'],
  },
  {
    name: 'Renault',
    popular: ['Kwid', 'Sandero', 'Logan', 'Duster', 'Triber', 'Kiger'],
  },
  {
    name: 'Datsun',
    popular: ['Go', 'Go+', 'Redi-Go'],
  },
  {
    name: 'Daihatsu',
    popular: ['Terios', 'Mira', 'Move', 'Hijet', 'Boon', 'Sirion'],
  },
  {
    name: 'Peugeot',
    popular: ['206', '207', '301', '307', '308', '3008', 'Partner', 'Boxer'],
  },
  {
    name: 'Volvo',
    popular: ['XC60', 'XC90', 'S60', 'FH', 'FM'],
  },
  {
    name: 'Mahindra',
    popular: ['Scorpio', 'Bolero', 'Pik Up', 'XUV500', 'KUV100'],
  },
  {
    name: 'Tata',
    popular: ['Indica', 'Xenon', 'Super Ace', 'Prima', 'LPT'],
  },
  {
    name: 'Great Wall',
    popular: ['Steed', 'Wingle', 'P-Series'],
  },
  {
    name: 'Haval',
    popular: ['H2', 'H6', 'Jolion', 'H9'],
  },
  {
    name: 'Chery',
    popular: ['QQ', 'Tiggo', 'Tiggo 4', 'Tiggo 7', 'Arrizo'],
  },
  {
    name: 'JAC',
    popular: ['J5', 'T6', 'T8', 'X200'],
  },
  {
    name: 'Foton',
    popular: ['Tunland', 'Aumark', 'Forland'],
  },
];

// Heavy commercial & truck brands common with Zambian transporters and the
// Copperbelt mining sector.
export const truckBrands = [
  'Sinotruk Howo', 'Shacman', 'FAW', 'Scania', 'MAN', 'DAF', 'Iveco',
  'Freightliner', 'Mercedes-Benz Actros', 'Volvo Trucks', 'Hino', 'Isuzu',
  'Fuso', 'Tata', 'Foton',
];

// Motorcycle & three-wheeler brands (boda boda and delivery use).
export const motorcycleBrands = [
  'Honda', 'Yamaha', 'Suzuki', 'Bajaj', 'TVS', 'Haojue', 'Lifan', 'Kawasaki',
  'Boxer', 'Sundiro',
];

// Vehicle body / category types listed on ZamWheelz.
export const bodyTypes = [
  'Sedans', 'Hatchbacks', 'SUVs', 'Crossovers', '4x4 & Off-road', 'Pickup Trucks',
  'Double Cabs', 'Vans & Minibuses', 'Trucks & Lorries', 'Motorcycles', 'Buses', 'Tractors',
];

// Major Zambian cities and towns served, for local SEO.
export const zambianCities = [
  'Lusaka', 'Kitwe', 'Ndola', 'Livingstone', 'Kabwe', 'Chingola', 'Mufulira',
  'Luanshya', 'Solwezi', 'Kasama', 'Chipata', 'Mazabuka', 'Choma', 'Mongu',
  'Kafue', 'Mansa',
];

export default carMakes;
